var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDownBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-17"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#00AEEF",
    transform: "translate(25.000000, 25.000000) rotate(-180.000000) translate(-25.000000, -25.000000) ",
    cx: 25,
    cy: 25,
    r: 25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3522575,25.0025366 L28.8097427,20.5131707 C28.93248,20.3898537 29,20.2249756 29,20.0491707 C29,19.8732683 28.93248,19.7084878 28.8097427,19.5849756 L28.4191533,19.1918049 C28.2966097,19.0680976 28.1327986,19 27.9582345,19 C27.7836705,19 27.6200531,19.0680976 27.4974127,19.1918049 L22.1900662,24.5367805 C22.0669414,24.6606829 21.9995182,24.8262439 22,25.0022439 C21.9995182,25.1790244 22.0668445,25.3443902 22.1900662,25.4683902 L27.4924722,30.8081951 C27.6151126,30.9319024 27.77873,31 27.9533909,31 C28.1279549,31 28.2915724,30.9319024 28.4143097,30.8081951 L28.8048022,30.4150244 C29.0588984,30.159122 29.0588984,29.7425366 28.8048022,29.4867317 L24.3522575,25.0025366 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    transform: "translate(25.500000, 25.000000) scale(-1, 1) rotate(-90.000000) translate(-25.500000, -25.000000) "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownBlue);
export default __webpack_public_path__ + "static/media/arrow-down-blue.69f752822edb113db9852056e07e9948.svg";
export { ForwardRef as ReactComponent };